export default __webpack_public_path__ + "static/media/trr-drink-coffee-oatdraftlatte.81dbdb42.png";